/* eslint-disable @typescript-eslint/no-explicit-any */
import Api from '../../utils/api'
import MockData from '../../components/organisms/ConfigureAndBuy/api-mock-data.mock'

const ProductData = () => null

ProductData.getProductData = async (
  url: string,
  key: string,
  market: string,
  locale: string,
  channel: string,
  isMock: boolean = false
  // eslint-disable-next-line max-params
) => {
  if (isMock) {
    return MockData
  }

  const headers = {
    'Content-Type': 'application/json'
  }

  const API_PRODUCT_DATA = {
    url,
    options: {
      method: 'GET',
      headers
    }
  }

  const queryParams = new URLSearchParams({
    ...(market && { market }),
    ...(locale && { locale }),
    ...(channel && { channel })
  })

  const productUrl = `${API_PRODUCT_DATA.url}/products/v1.0/products/${key}?${queryParams.toString()}`

  const product = await Api.fetch(productUrl, API_PRODUCT_DATA.options)

  const response = await product?.json()

  return response
}

export default ProductData
